import ShiptypeBaseController from '../common/shiptype.base.controller'

class ShiptypeallController extends ShiptypeBaseController {
  /*@ngInject*/
  constructor(Auth, $state, User, Modal, ShiptypeService, $translate, $stateParams, $scope, $location) {

    super(Auth, $state, User, ShiptypeService, Modal, $translate, $stateParams, $location)

    this.id = 'shiptype.all'
    this.loading = true
    this.shiptypes = []
    this.page = 1
    this.total = 0
    this.pageLimit = 10
    this.maxPages = 10
    this.hasACL = {}
    this.searchText = '';
    this._status = 'all'
    this.shipTypeList = ['all', 'active', 'inActive', 'types']
    this.userStatus = this.shipTypeList.map((list) => {
      return {
        value: list,
        label: $translate.instant('ship_types.' + list)
      };
    });
    this.$location = $location;
    this.branchId = this.User.getUser().branchId;
  }

  $onInit() {
    let pageId = this.$stateParams.page
    if (pageId > 0) {
      this.page = pageId
    }
    this.loadData()
  }

  edit(shiptype) {
    this.$state.go('shiptype.edit', ({
      id: shiptype.id
    }))
  }

  delete(shiptype) {
    if (this.allowOnlyOnce) return;
    this.allowOnlyOnce = true;
    this.Modal.confirm({
      header: this.$translate.instant('common.confirm_delete_title'),
      message: this.$translate.instant('common.confirm_delete_message') + ` <strong>${shiptype.id}</strong>?`,
      callback: (({
        modal,
        $scope
      }) => {
        $scope.loading = true
        this.Service.remove(shiptype.id, this.branchId)
          .then((data) => {
            this.allowOnlyOnce = false;
            modal.close()
            this.refresh()
          })
      }),
      negative: (({
        modal,
      }) => {
        this.allowOnlyOnce = false;
        modal.close();
      }),
      type: 'danger'
    })
  }

  refresh() {
    this.loadData()
  }

  pageChange() {
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData()
  }

  loadData(search) {
    const searchObj = this.generateSearchObj();

    this.loading = true;
    this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit)
      .then((data) => {
        this.total = data.total
        this.loading = false
        this.shiptypes = data.results;
      })
      .catch((err) => {
        this.loading = false
        this.error = err.message
      })
  }

  generateSearchObj() {
    const searchObj = {
      queryJSON: {
        rules: [
          {
            group: {
              rules: [
                {
                  field: 'id',
                  condition: 'like',
                  data: `%${this.searchText}%`
                },
                {
                  field: 'description',
                  condition: 'like',
                  data: `%${this.searchText}%`
                },
              ],
              operator: 'OR'
            }
          }
        ],
        operator: 'AND'
      }
    };
    switch (this._status) {
      case 'active': {
        searchObj.queryJSON.rules.push({
          field: 'status',
          condition: '=',
          data: true
        });
        break;
      }
      case 'inActive': {
        searchObj.queryJSON.rules.push({
          field: 'status',
          condition: '=',
          data: false
        });
        break;
      }
    }
    return searchObj;
  }

  search() {
    this.page = 1;
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData();
  }
  toggleExpand(shiptype) {
    shiptype.expand = !shiptype.expand;
  }
}

export default ShiptypeallController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/shiptype/all/shiptype.all.controller.js